import { useEffect, useRef } from 'react';
import { PinchState, UsePinchZoomProps } from '../interfaces/pinchZoom.interface';
import { createTouchHandlers } from '../utils/pinchZoom.utils';

export default function usePinchZoom({ imageRef, imgContainerRef, enabled }: UsePinchZoomProps) {
  const pinchState = useRef<PinchState>({
    initialDistance: 0,
    initialScale: 1,
    originX: 0,
    originY: 0,
    active: false,
  });

  useEffect(() => {
    const img = imageRef?.current;

    if (!enabled || !img) {
      return;
    }

    const possibleContainer = (imgContainerRef && imgContainerRef.current) || img.parentElement;
    const containerEl = possibleContainer || document;

    const { handleTouchStart, handleTouchMove, handleTouchEnd } = createTouchHandlers(
      imageRef,
      pinchState,
    );

    containerEl.addEventListener(
      'touchstart',
      handleTouchStart as EventListener,
      { passive: false } as AddEventListenerOptions,
    );
    containerEl.addEventListener(
      'touchmove',
      handleTouchMove as EventListener,
      { passive: false } as AddEventListenerOptions,
    );
    containerEl.addEventListener('touchend', handleTouchEnd as EventListener);
    containerEl.addEventListener('touchcancel', handleTouchEnd as EventListener);
    return () => {
      containerEl.removeEventListener('touchstart', handleTouchStart as EventListener);
      containerEl.removeEventListener('touchmove', handleTouchMove as EventListener);
      containerEl.removeEventListener('touchend', handleTouchEnd as EventListener);
      containerEl.removeEventListener('touchcancel', handleTouchEnd as EventListener);
    };
  }, [enabled, imageRef, imgContainerRef]);
}
